import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { useTranslation } from 'react-i18next';
import IconInstallments from '@/assets/icons/heroIcons/Installments.svg';
import { DownloadButton } from '@/components/buttons';
import { DocumentSection } from '@/sections/documents/DocumentSection';
import { useRouter } from 'next/router';
import { FILES } from '@/constants/files';
export function InstallmentsConditions(props) {
  const $ = _c(60);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = ["termsAndConditions"];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation(t0);
  const {
    locale
  } = useRouter();
  let t1;
  if ($[1] !== t) {
    t1 = t("categories.6.title");
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <IconInstallments className="h-7 w-7 text-blue-500 lg:h-10 lg:w-10" />;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t) {
    t3 = t("categories.6.text");
    $[4] = t;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t3) {
    t4 = <p className="mb-8">{t3}</p>;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t) {
    t5 = t("categories.6.subtitle");
    $[8] = t;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t5) {
    t6 = <h3 className="mb-6 text-base font-bold lg:text-2xl">{t5}</h3>;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t) {
    t7 = t("categories.6.list.1");
    $[12] = t;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t7) {
    t8 = <li>{t7}</li>;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== t) {
    t9 = t("categories.6.list.2");
    $[16] = t;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== t9) {
    t10 = <li>{t9}</li>;
    $[18] = t9;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== t) {
    t11 = t("categories.6.list.3");
    $[20] = t;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== t11) {
    t12 = <li>{t11}</li>;
    $[22] = t11;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  let t13;
  if ($[24] !== t10 || $[25] !== t12 || $[26] !== t8) {
    t13 = <ul className="mb-8 list-disc space-y-3 pl-5 marker:text-blue-500">{t8}{t10}{t12}</ul>;
    $[24] = t10;
    $[25] = t12;
    $[26] = t8;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  let t14;
  if ($[28] !== locale) {
    t14 = FILES(locale);
    $[28] = locale;
    $[29] = t14;
  } else {
    t14 = $[29];
  }
  const t15 = t14.preContractualInformationInstallmentsExample;
  let t16;
  if ($[30] !== t) {
    t16 = t("categories.6.documents.preContractualInformation");
    $[30] = t;
    $[31] = t16;
  } else {
    t16 = $[31];
  }
  let t17;
  if ($[32] !== t14.preContractualInformationInstallmentsExample || $[33] !== t16) {
    t17 = <div className="mb-2 lg:mb-4"><DownloadButton to={t15} testId="preContractualInformationInstallments" analyticsParam="preContractualInformationInstallments" className="sm:w-full">{t16}</DownloadButton></div>;
    $[32] = t14.preContractualInformationInstallmentsExample;
    $[33] = t16;
    $[34] = t17;
  } else {
    t17 = $[34];
  }
  let t18;
  if ($[35] !== locale) {
    t18 = FILES(locale);
    $[35] = locale;
    $[36] = t18;
  } else {
    t18 = $[36];
  }
  const t19 = t18.contractInstallments;
  let t20;
  if ($[37] !== t) {
    t20 = t("categories.6.documents.contract");
    $[37] = t;
    $[38] = t20;
  } else {
    t20 = $[38];
  }
  let t21;
  if ($[39] !== t18.contractInstallments || $[40] !== t20) {
    t21 = <div className="mb-2 lg:mb-4"><DownloadButton to={t19} testId="contractInstallments" analyticsParam="contractInstallments" className="sm:w-full">{t20}</DownloadButton></div>;
    $[39] = t18.contractInstallments;
    $[40] = t20;
    $[41] = t21;
  } else {
    t21 = $[41];
  }
  let t22;
  if ($[42] !== locale) {
    t22 = FILES(locale);
    $[42] = locale;
    $[43] = t22;
  } else {
    t22 = $[43];
  }
  const t23 = t22.infoPermanentlyAccessibleToConsumerInstallments;
  let t24;
  if ($[44] !== t) {
    t24 = t("categories.6.documents.infoPermanentlyAccessibleToConsumerInstallments");
    $[44] = t;
    $[45] = t24;
  } else {
    t24 = $[45];
  }
  let t25;
  if ($[46] !== t22.infoPermanentlyAccessibleToConsumerInstallments || $[47] !== t24) {
    t25 = <DownloadButton to={t23} testId="infoPermanentlyAccessibleToConsumerInstallments" analyticsParam="infoPermanentlyAccessibleToConsumerInstallments" className="sm:w-full">{t24}</DownloadButton>;
    $[46] = t22.infoPermanentlyAccessibleToConsumerInstallments;
    $[47] = t24;
    $[48] = t25;
  } else {
    t25 = $[48];
  }
  let t26;
  if ($[49] !== t17 || $[50] !== t21 || $[51] !== t25) {
    t26 = <div className="inline-block">{t17}{t21}{t25}</div>;
    $[49] = t17;
    $[50] = t21;
    $[51] = t25;
    $[52] = t26;
  } else {
    t26 = $[52];
  }
  let t27;
  if ($[53] !== props || $[54] !== t1 || $[55] !== t13 || $[56] !== t26 || $[57] !== t4 || $[58] !== t6) {
    t27 = <DocumentSection title={t1} icon={t2} {...props}>{t4}{t6}{t13}{t26}</DocumentSection>;
    $[53] = props;
    $[54] = t1;
    $[55] = t13;
    $[56] = t26;
    $[57] = t4;
    $[58] = t6;
    $[59] = t27;
  } else {
    t27 = $[59];
  }
  return t27;
}